export const COLLECTIONS_PORTAL_BROADCAST_CHANNEL = 'COLLECTIONS_PORTAL_BROADCAST_CHANNEL';
export const bc = new BroadcastChannel(COLLECTIONS_PORTAL_BROADCAST_CHANNEL);
export const AUDIO_PLAYER_TOP_OFFSET_WITH_BANNER = 44;
export const AUDIO_PLAYER_TOP_OFFSET_WITHOUT_BANNER = 8;
export const CALL_AUDIT_MODE_QUERY = 'mode*callAudit';
